export var CAPTCHA_ACCESS_COOKIE_NAME = '__captcha-access-token';
export var CAPTCHA_BEFORE_BLOCKING_HISTORY_KEY = '__captcha-bb-history';
export var CAPTCHA_RETRY_KEY = '__captcha_retry_key';
export var CAPTCHA_RECREATE_KEY = '__captcha_recreate_key';
export var CAPTCHA_BLOCKED_TIMEOUT_KEY = '__captcha_blocked_timeout';
export var CAPTCHA_STAGE_KEY = '__captcha_stage_key';
export var CAPTCHA_TARGET_KEY = '__captcha_target';
export var CAPTCHA_ACTIVE_MESSAGE_ID = '__captcha_active_message_id';
export var CAPTCHA_QUEUED_MESSAGES = '__captcha_queued_messages';
export var CAPTCHA_MAX_RETRIES = 4;
export var CAPTCHA_MAX_RECREATE = 5;
export var CAPTCHA_BLOCKED_MESSAGE_KEY = 'blocked-message';
export var COOKIE_TOKEN_INVALID_MESSAGE = 'There is no valid cookie in request';